import ky from "ky";
import { API_BASE_MM } from "@/constants/api";
import { createUnauthorizedHook } from "@/apis/clients/kyHooks";

/**
 * Client for the MediaMath APIs, reached through this service's own proxy.
 *
 * Same-origin by design. The upstream APIs do not implement OPTIONS on these
 * routes, so a direct cross-origin call fails its CORS preflight and never
 * leaves the browser — which is what the /mm-api Vite dev proxy was working
 * around. The backend proxy is the production form of that, and it also
 * attaches the caller's platform token server-side, so no token is ever
 * handed to JavaScript.
 *
 * There is no Authorization header here on purpose. The session cookie rides
 * along automatically and the proxy supplies the credential.
 */
export const createMediaMathClient = () =>
  ky.create({
    baseUrl: API_BASE_MM,
    credentials: "same-origin",
    hooks: {
      afterResponse: [createUnauthorizedHook()],
    },
  });
